import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Button, IconButton, Popover, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EditIcon from "@mui/icons-material/Edit";
import LogoutIcon from "@mui/icons-material/Logout";

import LoginService from "../../services/loginService";
import { RootState } from "../../state";
import ProfileImg from "../ProfileImg/ProfileImg";
import UserMenuMail from "../UserMenuMail/UserMenuMail";

import { COLLECTION_TAB } from "../../pages/MyProfile/MyProfile";
import { SETTINGS_TAB } from "../../pages/MyProfile/Settings";
import { UserAvatarMenuText } from "../../styles/muiStyles";

const LoggedMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const loginData = useSelector((state: RootState) => state.login);

  const { setLogout } = LoginService();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        columnGap: 1,
        marginRight: "0.5rem",
      }}
    >
      <Box>
        <IconButton onClick={handleClick}>
          <ProfileImg imgUrl={loginData.profileImage?.url} size={30} />
        </IconButton>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          sx={{ zIndex: "4" }}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Box
            sx={{ boxShadow: 3, padding: "5px", bgcolor: "background.paper" }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: 1,
                alignItems: "start",
                justifyContent: "flex-start",
              }}
            >
              <Box>
                <Link
                  to={
                    "/my-profile/" +
                    loginData.userId +
                    "/" +
                    COLLECTION_TAB.COLLECTION +
                    "/overview"
                  }
                >
                  <Button
                    sx={{ fontWeight: "800 !important" }}
                    fullWidth
                    startIcon={<PersonIcon />}
                    onClick={handleClose}
                  >
                    <Typography sx={UserAvatarMenuText}>
                      My Collection
                    </Typography>
                  </Button>
                </Link>
              </Box>
              <Box>
                <Link
                  to={
                    "/my-profile/" +
                    loginData.userId +
                    "/" +
                    COLLECTION_TAB.SETTINGS +
                    "/" +
                    SETTINGS_TAB.MY_ACCOUNT
                  }
                >
                  <Button
                    sx={{ fontWeight: "800 !important" }}
                    fullWidth
                    startIcon={<EditIcon />}
                    onClick={handleClose}
                  >
                    <Typography sx={UserAvatarMenuText}>
                      Edit Profile
                    </Typography>
                  </Button>
                </Link>
              </Box>
              <Box sx={{ width: "100%" }}>
                <Button
                  sx={{
                    fontWeight: "800 !important",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                  onClick={setLogout}
                  fullWidth
                  startIcon={<LogoutIcon />}
                >
                  <Typography sx={UserAvatarMenuText}>Logout</Typography>
                </Button>
              </Box>
            </Box>
          </Box>
        </Popover>
      </Box>

      <Box>
        <UserMenuMail />
      </Box>
    </Box>
  );
};

export default LoggedMenu;
